// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from 'react';
import './Button.css';

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  variant?: 'primary' | 'secondary';
  icon?: React.ReactNode;
  type?: 'button' | 'submit';
}

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  disabled = false,
  variant = 'primary',
  icon,
  type = 'button'
}) => {
  const buttonClass = `interview-button interview-button-${variant}`;

  return (
    <button type={type} className={buttonClass} onClick={onClick} disabled={disabled}>
      {icon && <span className="interview-button-icon">{icon}</span>}
      {children}
    </button>
  );
};

export default Button;
